import { api } from "@/lib/api";

export interface PageView {
  customer_org_id: string;
  id: string;
  session_id: string;
  person_id: string;
  timestamp: string;
  url: string;
  referrer_url: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_content: string | null;
  utm_term: string | null;
  page_type: string;
  web_session_channel: string;
}

export interface WebSession {
  id: string;
  customer_org_id: string;
  start_timestamp: string;
  end_timestamp: string;
  initial_referrer_url: string | null;
  initial_utm_source: string | null;
  initial_utm_medium: string | null;
  initial_utm_campaign: string | null;
  page_view_count: number;
  web_session_channel: string;
}

export interface WebSessionResponse {
  session: WebSession;
  page_views: PageView[];
}

export function useWebSession(sessionId: string | null) {
  return api.useQuery<WebSessionResponse>(
    `datahub/web-sessions/${sessionId}/`,
    {
      enabled: !!sessionId,
    },
  );
}
